import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import ApiDocument from '@/components/ApiDocument'
import ArWebSample from '../components/ArWebSample.vue'
import GameMock from '../components/GameMock.vue'


Vue.use(Router)

const gamelistRoutes = [
  {
    path: '/',
    name: 'HelloWorld',
    component: HelloWorld
  },
  {
    path: '/ApiDocument',
    name: 'ApiDocument',
    component: ApiDocument
  },
  {
    path: '/ArWebSample',
    name: 'ArWebSample',
    component: ArWebSample
  },
  {
    path: '/GameMock',
    name: 'GameMock',
    component: GameMock
  },
]

const apiRoutes = [
  {
    path: '/HelloWorld',
    name: 'HelloWorld',
    component: HelloWorld
  },
  {
    path: '/',
    name: 'ApiDocument',
    component: ApiDocument
  },
  {
    path: '/ArWebSample',
    name: 'ArWebSample',
    component: ArWebSample
  }
]

const onlyGamelist = [
  {
    path: '/',
    name: 'HelloWorld',
    component: HelloWorld
  },
  {
    path: '/ArWebSample',
    name: 'ArWebSample',
    component: ArWebSample
  }
]

var config = gamelistRoutes;

if (["demosite"].includes(process.env.NODE_ENV)) {
  config = onlyGamelist;
}

if (["test"].includes(process.env.NODE_ENV)) {
  config = onlyGamelist;
}

if (["staging"].includes(process.env.NODE_ENV)) {
  config = apiRoutes;
}

export default new Router({
  routes: config,
  mode: 'history',
  base: window.location.hostname === 'staging.tiangeo168.com' ? '/demo/' : '/',
})

// const getBaseUrl = () => {
//   const hostname = window.location.hostname;
//   if (hostname === 'staging.tiangeo168.com') {
//     return '/demo/';
//   }
//   return '/';
// };



// WEBPACK FOOTER //
// ./src/router/index.js